import {NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Calendar, PaginationComponent, PaginationConfig, PAGINATION_CONFIG_TOKEN} from '@westjetairlines/wjesd-component-library';
import {SearchRoutingModule} from './search-routing.module';
import {SearchComponent} from './search.component';
import {PipeModule} from '../shared/pipes/pipe.module';
import {ValidationModule} from '../shared/validation/validation.module';

export let paginationConfig = new PaginationConfig(10, 50, true, true, true);

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PipeModule,
    ValidationModule,
    SearchRoutingModule
  ],
  declarations: [
    SearchComponent,
    Calendar,
    PaginationComponent
  ],
  providers: [
    { provide: PAGINATION_CONFIG_TOKEN, useValue: new PaginationConfig() }
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})
export class SearchModule { }



// WEBPACK FOOTER //
// ./src/app/search/search.module.ts